import { render, staticRenderFns } from "./EditTeamList.vue?vue&type=template&id=ed8bbec6&scoped=true"
import script from "./EditTeamList.vue?vue&type=script&lang=js"
export * from "./EditTeamList.vue?vue&type=script&lang=js"
import style0 from "./EditTeamList.vue?vue&type=style&index=0&id=ed8bbec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8bbec6",
  null
  
)

export default component.exports